<template>
    <div class="footer">
        <div class="text--center">
            <div class="footer__copyright">
                © 2022 eventstorming.net.cn 版权所有 备案号：
                <a
                    href="https://beian.miit.gov.cn"
                    target="_blank"
                    rel="nofollow"
                    >粤ICP备2022107299号</a
                >
                <br />
                反馈|合作：1031905799@qq.com
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "Footer",
};
</script>

<style lang="scss" scoped>
.footer {
    align-self: flex-end;
    margin-top: 80px;
    margin-bottom: 20px;
    width: 1380px;
    height: 60px;
    line-height: 30px;

    .text--center {
        text-align: center;
        color: #8590a6;

        a {
            color: #8590a6;
        }
    }
}

h1 {
    font-size: 34px;
    margin: 0;
    line-height: 48px;
    color: #555;
}

h3 {
    text-align: center;
    margin: 0;
    font-size: 18px;
    color: #1f2f3d;
    font-weight: 400;
}

p {
    font-size: 14px;
    color: #99a9bf;
    padding: 0 25px;
    line-height: 20px;
}
</style>
